<header class="oyan-ui-header iot-platform-ui-header flex flex-wrap items-center">
  <button
    (click)="onToggleMenuClick()"
    [matTooltipClass]="'regular-tooltip'"
    [matTooltip]="'HEADER.TOGGLE_NAVIGATION_TOOLTIP' | translate"
    class="regular-round-button toggle-navigation-btn mr-2 !flex !items-center"
    mat-icon-button
  >
    <mat-icon>menu</mat-icon>
  </button>

  <img class="ml-3" (click)="onLogoClick()" [src]="'assets/images/' + logoIconName()" alt="" />
  <span class="border-right"></span>
  <img class="ml-5" (click)="onLogoClick()" [src]="appLogo" alt="" />

  @if (environment.envType !== 'prod') {
    <span class="environment-tag ml-5" [ngClass]="environment.envType">{{ environment.envName }}</span>
  }

  <span class="flex-1"></span>

  <mat-select
    (click)="allowSwitchBusinessProfile() ? onBusinessProfileListClicked($event) : $event.preventDefault()"
    (selectionChange)="switchBusinessProfile($event)"
    [formControl]="selectedProfileControl"
    class="navbar-business-profile-select border-right ml-5"
  >
    <mat-select-trigger>{{ selectedProfile()?.name }}</mat-select-trigger>
    @for (profile of businessProfiles(); track profile.id) {
      <mat-option [disabled]="profile.notCoveredByUserEntityAt" [value]="profile">
        <span class="bp-list--bp-name">{{ profile.name }}</span>
        @if (profile.notCoveredByUserEntityAt) {
          <mat-icon [matTooltip]="'HEADER.BUSINESS_PROFILE_OUT_OF_SCOPE' | translate" class="bp-list--info-icon" matTooltipClass="regular-tooltip"
            >info_outlined
          </mat-icon>
        }
      </mat-option>
    }
  </mat-select>

  <button [matMenuTriggerFor]="menu" class="user-button ml-5" color="accent" mat-mini-fab data-cy="feature-app-shell-user-menu-btn">
    <p data-hj-suppress>{{ initials() }}</p>
  </button>
  <mat-menu #menu="matMenu" class="flex flex-row">
    @if (allowRedirectToMyProfile()) {
      <button (click)="onMyProfileClick()" mat-menu-item>{{ 'HEADER.MY_PROFILE' | translate }}</button>
      <mat-divider></mat-divider>
    }
    <button (click)="onLogout()" mat-menu-item data-cy="feature-app-shell-logout-btn">{{ 'HEADER.LOGOUT' | translate }}</button>
  </mat-menu>
</header>
